module.exports = __webpack_public_path__ + "static/media/faq-sub-record-doc.1df10389.svg";